export const PERSONAL = {
  name: 'Carlos Varas Alonso',
  alias: 'zonary123',
  email: 'carlosvarasalonso10@gmail.com',
  github: 'https://github.com/zonary123',
  linkedin: 'https://www.linkedin.com/in/carlos-varas-alonso-7324a72b2/',
} as const;
